<div class="status-form">
    <form [formGroup]="form" class="form-content">
        <!-- Name section -->
        <div class="section-title">{{ 'permit.config.statuses.form_section_name' | translate }}</div>

        <div class="name-form">
            <app-form-input-v2
                [label]="'permit.config.common.name_fr' | translate"
                placeholder=""
                formControlName="nameFr"
            >
                <app-form-error *ngIf="form.get('nameFr').touched && form.get('nameFr').hasError('required')">
                    {{ 'permit.config.common.required_error' | translate }}
                </app-form-error>
            </app-form-input-v2>

            <app-form-input-v2
                [label]="'permit.config.common.name_en' | translate"
                placeholder=""
                formControlName="nameEn"
            >
                <app-form-error *ngIf="form.get('nameEn').touched && form.get('nameEn').hasError('required')">
                    {{ 'permit.config.common.required_error' | translate }}
                </app-form-error>
            </app-form-input-v2>
        </div>

        <!-- Type section -->
        <div class="section-title">{{ 'permit.config.statuses.type' | translate }}</div>

        <div class="type-form">
            <app-form-select-v2
                [placeholder]="'permit.config.statuses.type_placeholder' | translate"
                formControlName="type"
                [options]="statusTypeOptions"
                [invalid]="form.get('type').touched && form.get('type').invalid"
            >
                <app-form-error *ngIf="form.get('type').touched && form.get('type').hasError('required')">
                    {{ 'permit.config.common.required_error' | translate }}
                </app-form-error>
            </app-form-select-v2>
        </div>

        <!-- Color section -->
        <div class="color-row">
            <span class="color-label">{{ 'permit.config.statuses.color' | translate }}</span>
            <input type="color" class="color-input" formControlName="color" />
        </div>

        <!-- Terminal toggle -->
        <div class="terminal-row">
            <app-form-toggle formControlName="terminal">
                {{ 'permit.config.statuses.terminal' | translate }}
            </app-form-toggle>
        </div>

        <!-- Save / Cancel -->
        <div class="form-actions">
            <button type="button" mat-button class="cancel-button" (click)="onCancel()">
                {{ 'permit.config.common.cancel' | translate }}
            </button>
            <button
                type="button"
                mat-flat-button
                class="save-button"
                [disabled]="form.invalid || isSaving"
                (click)="onSave()"
            >
                {{ 'permit.config.common.save' | translate }}
            </button>
        </div>
    </form>
</div>
